export function formatDate(value) {
  if (!value) return 'Not available';
  return new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(value));
}

export function formatBytes(size) {
  if (!Number.isFinite(size)) return 'Not available';
  if (size < 1024 * 1024) return `${Math.round(size / 1024)} KB`;
  return `${(size / (1024 * 1024)).toFixed(2)} MB`;
}

export function hasRequiredValues(values, keys) {
  return keys.every((key) => values[key]?.trim());
}

export function channelClass(channel) {
  return `firmware-channel firmware-channel-${channel.toLowerCase()}`;
}

export function firmwareChannels(firmware) {
  const channels = Array.isArray(firmware.promotions)
    ? firmware.promotions.map((promotion) => promotion?.toChannel)
    : [];
  return [...new Set(channels.filter((channel) => ['INTERNAL', 'ALPHA', 'BETA', 'PRODUCTION'].includes(channel)))];
}

export function statusClass(status) {
  return `firmware-status firmware-status-${status.toLowerCase().replace(/\s+/g, '-')}`;
}
